import Pages from './Pages.tsx'

import styles from './pageLayout.module.scss'
import { useEffect } from 'react'
import { createSpinner } from '@syncfusion/ej2-react-popups'
import { DynamicFooterFaceLift, DynamicHeaderFaceLift } from 'dynamicelement'

const PageLayout = () => {
  useEffect(() => {
    const html = document.getElementById('mainTarget')
    if (html instanceof HTMLElement) {
      createSpinner({
        target: html,
      })
    }
  }, [])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <DynamicHeaderFaceLift title="Inhouse" />
      <div id={'mainTarget'} className={styles.nwMainContent}>
        <Pages />
        <DynamicFooterFaceLift />
      </div>
    </div>
  )
}
export default PageLayout
